<template>
  <!-- 综合查询 -->
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems glo_bgcMainColor"
          @click="loadSure()"
          v-permission="'admin:dispatch:checixiangqing:task:load:confirm'"
          >装货确认</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="unloadSure()"
          v-permission="'admin:dispatch:checixiangqing:task:unload:confirm'"
          >卸货确认</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="cancelLoadSure()"
          v-permission="'admin:dispatch:checixiangqing:task:load:confirm:cancel'"
          >取消装货</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="cancelunloadSure()"
          v-permission="'admin:dispatch:checixiangqing:task:load:confirm:cancel'"
          >取消卸货</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="arrivalLoad()"
          v-permission="'admin:dispatch:checixiangqing:task:load:to:car'"
          >装货到车</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="arrivalUnload()"
          v-permission="'admin:dispatch:checixiangqing:task:unload:to:car'"
          >卸货到车</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="cancelLoadSure()"
          v-permission="'admin:dispatch:checixiangqing:task:load:to:car:cancel'"
          >取消装货到车</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="cancelunloadSure()"
          v-permission="'admin:dispatch:checixiangqing:task:unload:to:car:cancel'"
          >取消卸货到车</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="wtl_chargeback()"
          v-permission="'admin:dispatch:checixiangqing:task:tui:dan'"
          >退单</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="wtl_outgoingStation()"
          v-permission="'admin:dispatch:checixiangqing:task:wai:fa:dao:zan'"
          >外发到站</el-button
        >
      </div>
    </div>
    <mytable
      :maxHeight="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isselection="true"
      :isShowMoreOperate="false"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
    >
      <template #goodsName="{ row }" v-if="hasPermiss('admin:dispatch:checixiangqing:task:goods')">
        <div class="linkTabel" @click.stop="getGoodsNameDetails(row)">
          货物明细
        </div>
      </template>
    </mytable>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageStart"
      :page-size="pageTotal"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageCount"
    >
    </el-pagination>
    <!-- 卸货确认 -->
    <myDialog
      diaWidth="40%"
      dialogTitle="卸货确认"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="isShowDialog2 = false"
      @diaCancelBtn="isShowDialog2 = false"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog2"
          class="diaForm"
          ref="dialogFormRef"
          :model="dialogForm2"
          label-width="100px"
        >
          <el-form-item prop="unloadType" label="" label-width="0">
            <el-radio-group v-model="dialogForm2.unloadType">
              <el-radio
                :label="item.val"
                v-for="(item, idx) in unloadTypeList"
                :key="idx"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item style="width: 100%" label="卸货图片:">
            <uploadimgs
              @input="changeFileList2"
              :fileNameLists="fileNameLists2"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
          <el-form-item prop="remarks" label="备注:" style="width: 100%">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>
          <template v-if="dialogForm2.unloadType == 'hui_cang:unload_type'">
            <el-row style="width: 100%">
              <el-col :span="12">
                <el-form-item
                  prop="returnCangReason"
                  label="回仓原因:"
                  v-if="dialogForm2.unloadType == 'hui_cang:unload_type'"
                >
                  <el-select
                    v-model="dialogForm2.returnCangReason"
                    placeholder="请选择"
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in returnCangReasonList"
                      :key="index"
                      :label="item.val"
                      :value="item.confDictId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  prop="returnCangStorageId"
                  label="回仓仓库:"
                  v-if="dialogForm2.unloadType == 'hui_cang:unload_type'"
                >
                  <el-select
                    v-model="dialogForm2.returnCangStorageId"
                    placeholder="请选择"
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in storageList"
                      :key="index"
                      :label="item.name"
                      :value="item.documentId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <template v-if="dialogForm2.unloadType == 'zheng_chang:unload_type'">
            <el-form-item
              prop="isOutGoing"
              label=""
              v-if="dialogForm2.unloadType == 'zheng_chang:unload_type'"
            >
              <el-checkbox
                v-model="dialogForm2.isOutGoing"
                :true-label="1"
                :false-label="0"
                >外发到站</el-checkbox
              >
            </el-form-item>

            <el-form-item
              style="width: 100%"
              v-if="dialogForm2.isOutGoing == '1'"
              label="外发图片:"
            >
              <uploadimgs
                @input="changeFileList3"
                :fileNameLists="fileNameLists3"
                :limit="9"
              ></uploadimgs>
            </el-form-item>
            <el-form-item
              v-if="dialogForm2.isOutGoing == '1'"
              prop="outgoingRemarks"
              label="外发备注:"
              style="width: 100%"
            >
              <el-input
                type="textarea"
                rows="2"
                v-model="dialogForm2.outgoingRemarks"
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </myDialog>
    <!-- 退单 -->
    <myDialog
      diaWidth="40%"
      dialogTitle="退单"
      :isShowDialog="isShowDialog4"
      @handleCloseDia="isShowDialog4 = false"
      @diaCancelBtn="isShowDialog4 = false"
      @diaConfirmBtn="diaConfirmBtn4('dialogFormRef4')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog4"
          class="diaForm"
          ref="dialogFormRef4"
          :model="dialogForm4"
          label-width="100px"
        >
          <el-form-item
            prop="returnCangReason"
            label="退单原因:"
            style="width: 100%"
          >
            <el-select
              v-model="dialogForm4.returnCangReason"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="(item, index) in returnCangReasonList"
                :key="index"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="remarks" label="备注:" style="width: 100%">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm4.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 外发到站 -->
    <myDialog
      diaWidth="40%"
      dialogTitle="外发到站"
      :isShowDialog="isShowDialog5"
      @handleCloseDia="isShowDialog5 = false"
      @diaCancelBtn="isShowDialog5 = false"
      @diaConfirmBtn="diaConfirmBtn5('dialogFormRef5')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog5"
          class="diaForm"
          ref="dialogFormRef5"
          :model="dialogForm5"
          label-width="100px"
          :rules="rulesForm5"
        >
          <el-form-item style="width: 100%" label="上传图片:">
            <uploadimgs
              @input="changeFileList5"
              :fileNameLists="fileNameLists5"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
          <el-form-item style="width: 100%" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm5.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 弹窗 装货确认-->
    <myDialog
      diaWidth="60%"
      dialogTitle="装货确认"
      :isShowDialog="isShowDialog1"
      @handleCloseDia="isShowDialog1 = false"
      @diaCancelBtn="isShowDialog1 = false"
      @diaConfirmBtn="diaConfirmBtn1"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog1"
          class="diaForm"
          ref="dialogForm1"
          :model="dialogForm1"
          label-width="100px"
          :rules="rulesForm1"
        >
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm1.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="装货图片:">
            <uploadimgs
              @input="changeFileList_zh"
              :fileNameLists="fileNameLists1"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 货物信息 -->
    <goodsnamedetail
      diaWidth="80%"
      dialogTitle3="货物明细"
      :isShowDialog3="isShowDialog3"
      :goodsNameData="goodsNameData"
      @handleCloseDia3="isShowDialog3 = false"
    ></goodsnamedetail>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import goodsnamedetail from "@/components/goodsNameDetails.vue";
export default {
  props: {
    dispatchId: {},
    isSee: {},
    type: {
      type: String,
      require: false,
      default: "edit",
    },
    op: {
      type: String,
      require: false,
      default: "edit",
    },
  },
  mixins: [tableListNew],
  components: {
    queryCondition,
    sorttable,
    paging,
    queryBtns,
    mytable,
    myDialog,
    uploadimgs,
    goodsnamedetail
  },
  data() {
    return {
      isShowDialog3: false,
      goodsNameData: [],
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "详情", //按钮名称
          methods: "detail", //当前页面的方法
          param: 1, //自定义参数标记
          permission:this.hasPermiss('admin:dispatch:checixiangqing:task:trace')
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      //需要单独点击的列字段名数组
      fieldList: ["dispatchNumber"],
      Operatewidth: "220px", //操作列的列宽
      //=======================导出相关 结束 =======================

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "CarTimingTakeMode", //  页面标识
      reportFiledsNumber: "admin_dispatch_task_mode_list", // 动态 条件、表头
      activeName: "first",
      selectedId: "",
      selectedNumber: "",
      showTraceDialog: false,
      isShowDialog2: false,
      fileNameLists1: [],
      fileNameLists2: [],
      fileNameLists3: [],
      fileNameLists5: [],
      isOutGoingList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],
      dialogForm2: {
        // 弹窗表单数据
        isOutGoing: "0",
        fileIds: [],
        outgoingFileIds: [],
        outgoingRemarks: "",
        remarks: "",
        returnCangReason: "",
        returnCangStorageId: "",
        taskIds: [],
        unloadType: "",
      },
      unloadTypeList: [
        {
          name: "正常卸货",
          val: "zheng_chang:unload_type",
        },
        {
          name: "回仓卸货",
          val: "hui_cang:unload_type",
        },
      ],
      // ==== 弹窗组件属性 start ====
      isShowDialog1: false,
      dialogForm1: {
        // 弹窗表单数据
        remarks: "",
        taskStr: "",
      },
      isShowDialog4: false,
      dialogForm4: {
        taskIds: [],
        remarks: "",
        returnCangReason: "",
      },
      // 外发到站
      isShowDialog5: false,
      dialogForm5: {
        taskIds: [],
        fileIds: [],
        remarks: "",
      },
    };
  },
  mounted() {
    if (this.dispatchId) {
      this.getDetail();
    }
    this.getObjectUserDownList("storage"); //网点
    this.getConfDictValDownListApi("return_cang_reason"); //回仓原因
  },
  watch: {
    dispatchId: {
      handler(val) {
        if (!val) {
          return;
        }
        this.getDetail();
      },
    },
  },
  methods: {
    changeFileList_zh(array) {
      this.fileNameLists1 = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
    },
    // 选择图片
    changeFileList3(array) {
      this.fileNameLists3 = array;
    },
    // 选择图片
    changeFileList5(array) {
      this.fileNameLists5 = array;
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownListApi(type) {
      this.$COMAPI.getConfDictValDownList(type).then((res) => {
        // 回仓原因
        if (type == "return_cang_reason") {
          this.returnCangReasonList = res || [];
        }
      }); //送货方式
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "storage") {
          //获取网点列表
          this.storageList = res || [];
        }
      });
    },
    check(tips) {
      if (this.selectTableData.length == 0) {
        this.$message.warning("请选择需要操作的记录");
        return Promise.reject();
      }
      if (tips === false) {
        return Promise.resolve();
      }
      return this.$confirm(tips);
    },
    loadSure() {
      this.check("确定要把所选数据装货确认？")
        .then((res) => {
          this.$API
            .wtl_loadSure({
              taskIds: this.selectTableData.map((item) => item.taskId),
              fileIds: [],
              remarks: "",
            })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getDetail();
            });
        })
        .catch((err) => {});
    },
    unloadSure() {
      this.check(false)
        .then((res) => {
          this.isShowDialog2 = true;
        })
        .catch((err) => {});
    },
    cancelunloadSure() {
      this.check("确定要把所选数据取消卸货？")
        .then((res) => {
          this.$API
            .wtl_cancelunloadSure({
              taskIds: this.selectTableData.map((item) => item.taskId),
            })
            .then((dd) => {
              this.$message.success("保存成功");
              this.getDetail();
            });
        })
        .catch((err) => {});
    },
    cancelLoadSure() {
      this.check("确定要把所选数据取消装货？")
        .then((res) => {
          this.$API
            .wtl_cancelLoadSure({
              taskIds: this.selectTableData.map((item) => item.taskId),
            })
            .then((dd) => {
              this.$message.success("保存成功");
              this.getDetail();
            });
        })
        .catch((err) => {});
    },
    getDetail() {
      this.getData({
        dispatchId: this.dispatchId,
      });
    },
    arrivalLoad() {
      this.check("确定要把所选数据装货到车？")
        .then((res) => {
          this.$API
            .wtl_arrivalLoad({
              taskIds: this.selectTableData.map((item) => item.taskId),
            })
            .then((dd) => {
              this.$message.success("保存成功");
              this.getDetail();
            });
        })
        .catch((err) => {});
    },
    arrivalUnload() {
      this.check("确定要把所选数据卸货到车？")
        .then((res) => {
          this.$API
            .wtl_arrivalUnload({
              taskIds: this.selectTableData.map((item) => item.taskId),
            })
            .then((dd) => {
              this.$message.success("保存成功");
              this.getDetail();
            });
        })
        .catch((err) => {});
    },
    cancelArrivalLoad() {
      this.check("确定要把所选数据取消装货到车？")
        .then((res) => {
          this.$API
            .wtl_cancelArrivalLoad({
              taskIds: this.selectTableData.map((item) => item.taskId),
            })
            .then((dd) => {
              this.$message.success("保存成功");
              this.getDetail();
            });
        })
        .catch((err) => {});
    },
    cancelArrivalUnload() {
      this.check("确定要把所选数据取消装货到车？")
        .then((res) => {
          this.$API
            .wtl_cancelArrivalUnload({
              taskIds: this.selectTableData.map((item) => item.taskId),
            })
            .then((dd) => {
              this.$message.success("保存成功");
              this.getDetail();
            });
        })
        .catch((err) => {});
    },
    diaConfirmBtn2(formName) {
      let param = JSON.parse(JSON.stringify(this.dialogForm2));

      let arr1 = this.fileNameLists2.map((item) => {
        return item.name;
      });
      let arr2 = this.fileNameLists3.map((item) => {
        return item.name;
      });
      param.taskIds = this.selectTableData.map((item) => item.taskId);
      param.fileIds = arr1 || [];
      param.outgoingFileIds = arr2 || [];
      this.$API.wtl_unloadSure(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog2 = false;
        this.getDetail();
      });
    },
    // 退单
    wtl_chargeback() {
      this.check(false)
        .then((res) => {
          this.isShowDialog4 = true;
          this.getConfDictValDownList("return_cang_reason"); //回仓原因
        })
        .catch((err) => {});
    },
    //  弹窗确认保存事件(卸货确认)
    diaConfirmBtn4(formName) {
      let param = JSON.parse(JSON.stringify(this.dialogForm4));
      param.taskIds = this.selectTableData.map((item) => item.taskId);
      this.$API.wtl_chargeback(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog4 = false;
        this.getDetail();
      });
    },
    // 外发到站
    wtl_outgoingStation() {
      this.check(false)
        .then((res) => {
          this.isShowDialog5 = true;
        })
        .catch((err) => {});
    },
    //  弹窗确认保存事件(卸货确认)
    diaConfirmBtn5(formName) {
      let param = JSON.parse(JSON.stringify(this.dialogForm5));
      let arrs = [];
      this.fileNameLists5.forEach((item) => {
        arrs.push(item.name);
      });
      param.fileIds = arrs;
      param.taskIds = this.selectTableData.map((item) => item.taskId);
      this.$API.wtl_outgoingStation(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog5 = false;
        this.getDetail();
      });
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      let fileIds = this.fileNameLists1.map((item) => {
        return item.name;
      });
      this.$API
        .wtl_loadSure({
          taskIds: this.selectTableData.map((item) => item.taskId),
          fileIds: fileIds || [],
          remarks: this.dialogForm1.remarks || "",
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.getDetail();
          this.isShowDialog1 = false;
        });
    },
    // 查看货物明细:
    getGoodsNameDetails(row) {
      // this.dialogForm2 = row;
      this.$API.wtl_getTaskItems({ taskId: row.taskId }).then((res) => {
        this.goodsNameData = res.data.result || [];
        this.isShowDialog3 = true;
      });
    },
  },
};
</script>


<style scoped lang="less">
.container {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
</style>
